export default function Gallery() {
  const images = [
    {
      url: 'https://static.readdy.ai/image/04f309692b2e018ede3a87223bcd45f5/7915f7a5564e3d9e6490ad1facfe96ca.jpeg',
      title: 'Services BR CLEAN AUTO'
    },
    {
      url: 'https://static.readdy.ai/image/04f309692b2e018ede3a87223bcd45f5/a5f3350c78a924945542fb14adf8c415.jpeg',
      title: 'Nettoyage Intérieur Professionnel'
    },
    {
      url: 'https://static.readdy.ai/image/04f309692b2e018ede3a87223bcd45f5/f77a78ac1a4d56775474ac46164a794b.jpeg',
      title: 'Nettoyage Extérieur Premium'
    },
    {
      url: 'https://public.readdy.ai/ai/img_res/30d52420d9256ed4be376edcfbe9d534.jpg',
      title: 'Pressing des Sièges'
    },
    {
      url: 'https://static.readdy.ai/image/04f309692b2e018ede3a87223bcd45f5/5e2e0cd6749ae482784edaaf193c5e33.jpeg',
      title: 'Nettoyage des Jantes'
    },
    {
      url: 'https://static.readdy.ai/image/04f309692b2e018ede3a87223bcd45f5/9eb2683ea4a4a49ab67bfda3fa46735d.jpeg',
      title: 'Nettoyage des Tapis'
    }
  ];

  return (
    <section id="gallery" className="py-20 bg-gradient-to-b from-gray-50 to-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Notre Galerie
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Découvrez la qualité de notre travail à travers nos réalisations
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {images.map((image, index) => (
            <div
              key={index}
              className="group relative overflow-hidden rounded-2xl shadow-lg hover:shadow-xl transition-all duration-300 cursor-pointer"
            >
              <div className="w-full h-80">
                <img
                  src={image.url}
                  alt={image.title}
                  className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-500"
                />
              </div>
            </div>
          ))}
        </div>

        <div className="mt-16 text-center">
          <p className="text-gray-600 mb-6">Suivez-nous sur Instagram pour plus de photos et d'actualités</p>
          <a
            href="https://instagram.com/BR_.clean63"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center bg-gradient-to-r from-purple-600 to-pink-600 text-white px-8 py-4 rounded-lg font-semibold hover:from-purple-700 hover:to-pink-700 transition-all whitespace-nowrap"
          >
            <i className="ri-instagram-line text-xl mr-2"></i>
            Suivez @BR_.clean63
          </a>
        </div>
      </div>
    </section>
  );
}